template = require('./province_options.html.slim')
controller = require('./province_options_controller')

angular.module('wbComponents').directive 'wbProvinceOptions', ->
  scope:
    noSelectText: '='
  restrict: 'E'
  replace: true
  templateUrl: template
  controller: controller
  controllerAs: 'ctrl'
